import {
  ForbiddenError,
  NotFoundError,
  UnauthorizedError,
} from "../../helpers/api";

// 401/403/404 は再試行しても結果が変わらない確定的なエラーのためリトライしない。
// それ以外(ネットワーク起因の可能性がある UnexpectedError 等)はデフォルト同様、最大3回までリトライする。
export const shouldRetryApiQuery = (failureCount: number, error: unknown) => {
  if (
    error instanceof UnauthorizedError ||
    error instanceof ForbiddenError ||
    error instanceof NotFoundError
  ) {
    return false;
  }
  return failureCount < 3;
};
